import { Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { proxmoxScanners } from "./proxmox";
import { baramundiScanners } from "./baramundi";
import { fortiGateScanners } from "./fortigate";
import { icinga2Scanners } from "./icinga";
import { intuneScanners } from "./intune";
import { netboxScanners } from "./netbox";
import { netdataScanners } from "./netdata";
import { octopusScanners } from "./octopus";
import { networkScanners } from "./network/section";
import { sentinalOneScanners } from "./sentinalone/section";
import { generalScanners } from "./general/section";
import {
  AnketaCheckPermissionOptions,
  AnketaResourcesEnum,
} from "../../../../";
import { QuestionsRightsTypes } from "..";

export const opsanioScanners = (
  questionsRights: (
    q: QuestionsRightsTypes,
    options?: AnketaCheckPermissionOptions<AnketaResourcesEnum.questionnaires>
  ) => void
): Section => {
  const scanners = new Section("scanners", [
    new Translation("en", "Scanners"),
    new Translation("de", "Scanners"),
  ]);
  questionsRights(scanners, {
    isInternal: true,
    isExternal: true,
  });

  scanners.help = [
    new Translation(
      "en",
      "In this section you can define your desired scanner."
    ),
    new Translation(
      "de",
      "In diesem Abschnitt können Sie den gewünschten Scanner definieren."
    ),
  ];

  scanners.addChild(generalScanners(questionsRights));

  const networkSection = networkScanners();
  questionsRights(networkSection, {
    isInternal: true,
    isExternal: true,
  });
  scanners.addChild(networkSection);

  const fortiGateSection = fortiGateScanners();
  questionsRights(fortiGateSection, {
    isInternal: true,
    isExternal: true,
  });
  scanners.addChild(fortiGateSection);

  const baramundiSection = baramundiScanners();
  questionsRights(baramundiSection, {
    isInternal: true,
    isExternal: true,
  });
  scanners.addChild(baramundiSection);

  const icinga2Section = icinga2Scanners();
  questionsRights(icinga2Section, {
    isInternal: true,
    isExternal: true,
  });
  scanners.addChild(icinga2Section);

  const intuneSection = intuneScanners();
  questionsRights(intuneSection, {
    isInternal: true,
    isExternal: true,
  });
  scanners.addChild(intuneSection);

  const netboxSection = netboxScanners();
  questionsRights(netboxSection, {
    isInternal: true,
    isExternal: true,
  });
  scanners.addChild(netboxSection);

  const netdataSection = netdataScanners();
  questionsRights(netdataSection, {
    isInternal: true,
    isExternal: true,
  });
  scanners.addChild(netdataSection);

  const octopusSection = octopusScanners();
  questionsRights(octopusSection, {
    isInternal: true,
    isExternal: true,
  });
  scanners.addChild(octopusSection);

  const proxmoxSection = proxmoxScanners();
  questionsRights(proxmoxSection, {
    isInternal: true,
    isExternal: true,
  });
  scanners.addChild(proxmoxSection);

  const sentinalOneSection = sentinalOneScanners();
  questionsRights(sentinalOneSection, {
    isInternal: true,
    isExternal: true,
  });
  scanners.addChild(sentinalOneSection);

  return scanners;
};
